var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{attrs:{"separator":">"}},[_vm._l((_vm.currentPath),function(item){return [(item.path === '')?_c('BreadcrumbItem',[_vm._v(" "+_vm._s(item.title)+" ")]):_c('BreadcrumbItem',{attrs:{"to":{ name: item.path,params: item.params,query:item.query}}},[_vm._v(" "+_vm._s(item.title)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }